var exports = {
  "qr": "EditingMessageInput.module__footer___bmNBMU",
  "s6": "EditingMessageInput.module__footerLink___bmNBMU",
  "me": "EditingMessageInput.module__separator___bmNBMU",
  "EN": "EditingMessageInput.module__editor___bmNBMU",
};

module.exports = exports;
